import {Modal} from 'react-bootstrap'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import {useIntl} from 'react-intl'
import {useMoveToFolderData} from '../core/FileToFolderAuth'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {useState, useEffect} from 'react'
import {useAuth} from '../../auth'

export const AddFolderModal = ({
  setRenameFolderModal,
  renameFolderModal,
  onFolderRename,
  renameLoading,
  folderRenameId,
  newName,
  setNewName,
  heading,
  labelText,
  btnText,
  showBool,
  folderParentId,
  prevName,
  companyFolderContentId,
  activeContentId,
}: {
  setRenameFolderModal: (value: boolean) => void
  renameFolderModal: boolean
  onFolderRename: any
  renameLoading: boolean
  folderRenameId?: any
  newName: string
  setNewName: (value: string) => void
  heading: string
  labelText: string
  btnText: string
  showBool: boolean
  folderParentId?: number
  prevName?: any
  companyFolderContentId?: any
  activeContentId?: any
}) => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const {folderNameErr, setFolderNameErr} = useMoveToFolderData()
  const [inputValue, setInputValue] = useState<any>('')
  useEffect(() => {
    if (prevName) {
      const extractedName = prevName.includes('/')
        ? prevName.split('/').pop() 
        : prevName 

      setInputValue(extractedName || '')
    }
  }, [prevName]) // eslint-disable-line
  return (
    <>
      <Modal
        show={renameFolderModal}
        onHide={() => setRenameFolderModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({id: heading})}</h2>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label htmlFor='uploadLink' className='form-label'>
              {formatMessage({id: labelText})}
            </label>
            <ToolTipUI
              tooltipText={formatMessage({id: 'GLOBAL.TOOLTIP.CREATEFOLDER.FOLDERNAME'})}
            />
            <input
              type='text'
              className={` ${
                folderNameErr
                  ? 'form-control border border-danger font-size-13 font-weight-400'
                  : 'form-control font-size-13 font-weight-400'
              }`}
              placeholder={formatMessage({id: 'Enter folder name'})}
              value={prevName ? inputValue : newName}
              onChange={(e) => {
                setNewName(e.target.value)
                setInputValue(e.target.value)
                setFolderNameErr(false)
              }}
            />
            {folderNameErr && (
              <p className='text-danger'>{formatMessage({id: 'Error : Enter folder name '})}</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex flex-column flex-md-row gap-2 w-100 justify-content-end'>
            <BasicButton
              height='44px'
              border='none'
              color='#F5F8FA'
              // textColor='#7E8299'
              padding='12px 16px'
              onClick={() => {
                setRenameFolderModal(false)
                setNewName('')
              }}
              buttonText='Cancel'
              minWidth={56}
              customClass='order-2 order-md-1 bg-light'
            />

            <BasicButton
              height='44px'
              border='1px solid #4776E6'
              color='#4776E6'
              textColor='white'
              padding='12px 24px'
              onClick={() => {
                if (folderRenameId && showBool) {
                  onFolderRename('FOLDER', folderRenameId, newName, folderParentId)
                } else if (folderRenameId && !showBool) {
                  if (companyFolderContentId === activeContentId) {
                    onFolderRename(newName, +companyId!)
                  } else {
                    onFolderRename(newName)
                  }
                } else {
                  onFolderRename()
                }
              }}
              buttonText={btnText}
              minWidth={56}
              loading={renameLoading}
              disabled={renameLoading || prevName === inputValue}
              customClass='order-1 order-md-2'
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
